import Cookies from './cookies'
import DateTime from './datetime'
import Logger from './logger'
import httpClient from './httpClient'

let Util = {
    "cookies": Cookies,
    "http": httpClient,
    "logger": Logger,
    "datetime": DateTime
}

export default Util


// WEBPACK FOOTER //
// ./src/util/util.js